import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const PCIsReportUploadRequest = (filePath, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}ServiceDesk/GeneratePCIs`,
	params: { filePath, userId }
});

export const GetTemplateRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ServiceDesk/GetCellPlanningTemplate`,
	params: { userId }
});
